<ol class="breadcrumb" *ngIf="isCSRManager">
  <li *ngFor="let bc of breadcrumbs; let i = index" [ngClass]="{ active: i === breadcrumbs.lenght - 1 }">
    <a class="bc-link" routerLink="{{ bc.url }}">{{ bc.text }}</a>
  </li>
</ol>
